



import BlogPreviewComponent from "@/components/admin/blog/blogPreviewComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "BlogPreviewPage",
  components: {
    BlogPreviewComponent,
  },
})
export default class BlogPreviewPage extends Vue {}
